/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
display_init_widgets()
display_display_widgets()`,
    });

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
def display_init_widgets():
    #****display_init_widgets****#
    pass
    
def display_display_widgets():
    #****display_display_widgets****#
    pass

class DisplayWidget():
    def __init__(self, type, x, y, width, height, screen = 0, color='#ffffff', background_color='#00000', text='', alignment='left'):
        self.type = type
        self.x = x
        self.y = y
        self.width = width
        self.height = height
        self.screen = screen
        self.color = color
        self.background_color = background_color
        self.text = text
        self.alignment = alignment
    `,
    });


    return blocks;
};
